/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserRankingItemFromJSON, UserRankingItemToJSON, } from './UserRankingItem';
/**
 * Check if a given object implements the UserRankings interface.
 */
export function instanceOfUserRankings(value) {
    if (!('rankings' in value) || value['rankings'] === undefined)
        return false;
    return true;
}
export function UserRankingsFromJSON(json) {
    return UserRankingsFromJSONTyped(json, false);
}
export function UserRankingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rankings': (json['rankings'].map(UserRankingItemFromJSON)),
    };
}
export function UserRankingsToJSON(json) {
    return UserRankingsToJSONTyped(json, false);
}
export function UserRankingsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rankings': (value['rankings'].map(UserRankingItemToJSON)),
    };
}
